import { getMoreResults } from 'redux/actions/searchActions'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

const MINIMUM = 100

export const usePrintResultTiles = ({ openAll, setOpenAll, setIsLoading }) => {
  const dispatch = useDispatch()
  const [openPrintWindow, setOpenPrintWindow] = useState(false)
  const { count } = useSelector(({ search }) => search)

  const onPrintBtnClicked = () => {
    const resultTiles = document.querySelectorAll('#resultlist > div')
    const from = resultTiles.length
    const size = MINIMUM - from

    // load more results to fulfill minimum
    if (count > from && from < MINIMUM) {
      setIsLoading(true)
      dispatch(
        getMoreResults({
          from,
          size,
        })
      ).then(() => {
        setIsLoading(false)
        setOpenAll(true)
        setOpenPrintWindow(true)
      })
    } else {
      setOpenAll(true)
      setOpenPrintWindow(true)
    }
  }

  useEffect(() => {
    // wait until all accordions are open and
    // open print window only if print button was pressed
    if (openAll && openPrintWindow) {
      window.print()
      setOpenPrintWindow(false)
    }
  }, [openAll, openPrintWindow])

  return {
    onPrintBtnClicked,
  }
}
